<template>
    <div v-loading="loading">
        <div class="search-ctn">
            <div class="search-ctn-left">
                <div class="search-name">品牌</div>
                <el-input class="search-item" style="width: 100px; margin-bottom: 10px" size="small" v-model="searchData.brand" placeholder="请输入品牌"></el-input>
                <div class="search-name">车型</div>
                <el-input class="search-item" style="width: 120px; margin-bottom: 10px" size="small" v-model="searchData.modelName" placeholder="请输入车型"></el-input>
                <div class="search-name">年款</div>
                <el-input class="search-item" style="width: 100px; margin-bottom: 10px" size="small" v-model="searchData.modelYear" placeholder="请输入年款"></el-input>
                <div class="search-name">排量</div>
                <el-input class="search-item" style="width: 100px; margin-bottom: 10px" size="small" v-model="searchData.emission" placeholder="请输入排量"></el-input>
                <div class="search-name">发动机</div>
                <el-input class="search-item" style="width: 120px; margin-bottom: 10px" size="small" v-model="searchData.engine" placeholder="请输入发动机号"></el-input>
                <div>
                    <el-button size="small" icon="el-icon-search" class="search-btn btn-primary" style="margin-bottom: 10px" @click="handleSearch">查询</el-button>
                    <el-button size="small" icon="el-icon-refresh" class="search-btn" @click="resetSearch">重置</el-button>
                    <el-button v-if="IsShowOpBtn" size="small" type="danger" class="search-btn" @click="removeBind">批量移除</el-button>
                    <el-button v-if="IsShowOpBtn" size="small" class="search-btn btn-primary" @click="selectCarType">关联车型</el-button>
                </div>
            </div>
        </div>
        <div class="table-ctn" style="display: block">
            <div>
                <el-table
                    ref="seriesTable"
                    @selection-change="handleSelectionChange"
                    :header-cell-style="{ background: '#F2F6FC' }"
                    :data="tableData"
                    border=""
                    :span-method="handleSpanMethod"
                >
                    <el-table-column label="品牌" prop="BrandName" width="100" show-overflow-tooltip></el-table-column>
                    <el-table-column label="车型" prop="SeriesName" width="100" show-overflow-tooltip></el-table-column>
                    <el-table-column label="年款" prop="ModelYear" width="70" show-overflow-tooltip></el-table-column>
                    <el-table-column label="排量" prop="Emission" width="70" show-overflow-tooltip></el-table-column>
                    <el-table-column label="发动机" prop="EngineType" width="90" show-overflow-tooltip></el-table-column>
                    <el-table-column label="驱动类型" prop="DriveStyle" width="80" show-overflow-tooltip></el-table-column>
                    <el-table-column label="变速箱" prop="TransmissionType" width="90" show-overflow-tooltip></el-table-column>
                    <el-table-column label="配置等级" prop="SaleModel" min-width="100" show-overflow-tooltip></el-table-column>
                    <el-table-column label="销售型" prop="ModelDesc" min-width="200" show-overflow-tooltip></el-table-column>
                    <el-table-column type="selection" width="45"></el-table-column>
                </el-table>
            </div>
        </div>
        <!-- <div class="dialog-pagination-ctn" style="text-align: left">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="searchData.page"
                :page-sizes="[10, 20, 30, 40, 50, 100, 200]"
                :page-size="searchData.limit"
                layout="total, sizes, prev, pager, next, jumper"
                :total="tableDataLength"
            ></el-pagination>
        </div> -->
        <!--    车型选择    -->
        <el-dialog title="选择车系" append-to-body :close-on-click-modal="false" :visible.sync="dialogVisible" :close-on-press-escape="false" width="1380px">
            <selectSeries ref="selectSearise" :visible="dialogVisible" :selectOptions="tableData" :showSets="true" @confirmButton="confirmSeriesButton" />
        </el-dialog>
    </div>
</template>

<script>
import selectSeries from '@/components/business/goods/selectSeries';
export default {
    components: {
        selectSeries
    },
    props: {
        GoodsId: String,
        IsShowOpBtn: Boolean
    },
    data() {
        return {
            loading: false,
            tableData: [],
            tableDataLength: 0,
            seriesIds: [],
            searchData: {
                brand: '',
                modelName: '',
                modelYear: '',
                goodsId: '',
                emission: '',
                engine: '',
                page: 1,
                limit: 100
            },
            dialogVisible: false
        };
    },
    mounted() {
        this.searchData.goodsId = this.GoodsId;
        this.getTableData();
    },
    methods: {
        // 选择车型
        selectCarType() {
            this.dialogVisible = true;
        },
        handleSpanMethod({
            row, // 行
            column, // 列
            rowIndex, // 行索引
            columnIndex // 列索引
        }) {
            if (columnIndex === 0 || columnIndex === 1 || columnIndex === 2) {
                // 获取当前单元格的值
                const currentValue = row[column.property];

                // 获取上一行相同列的值
                const preRow = this.tableData[rowIndex - 1];
                const preValue = preRow ? preRow[column.property] : null;

                // 如果当前值和上一行的值相同，则将当前单元格隐藏
                if (currentValue === preValue) {
                    return {
                        rowspan: 0,
                        colspan: 0
                    };
                } else {
                    // 否则计算当前单元格应该跨越多少行
                    let rowspan = 1;
                    for (let i = rowIndex + 1; i < this.tableData.length; i++) {
                        const nextRow = this.tableData[i];
                        const nextValue = nextRow[column.property];
                        if (nextValue === currentValue) {
                            rowspan++;
                        } else {
                            break;
                        }
                    }
                    return {
                        rowspan,
                        colspan: 1
                    };
                }
            }
        },
        resetSearch() {
            this.searchData.brand = '';
            this.searchData.modelName = '';
            this.searchData.modelYear = '';
            this.searchData.emission = '';
            this.searchData.engine = '';
            this.searchData.page = 1;
            this.searchData.limit = 100;
        },
        getTableData() {
            this.loading = true;
            this.$util
                .axiosGet({
                    url: '/api/EntpGoods/GetGoodsBindSeriesDatas',
                    data: this.searchData
                })
                .then(res => {
                    let data = res.data;
                    if (data) {
                        this.tableData = data;
                        this.tableDataLength = res.count;
                    } else {
                        this.tableData = [];
                        this.tableDataLength = 0;
                    }
                    this.loading = false;
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        handleSearch() {
            this.searchData.page = 1;
            this.getTableData();
        },
        handleSizeChange(val) {
            this.searchData.page = 1;
            this.searchData.limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.searchData.page = val;
            this.getTableData();
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
            let idList = [];
            for (let i = 0; i < val.length; i++) {
                idList.push(val[i].AutoSerieId);
            }
            this.seriesIds = idList;
        },
        removeBind() {
            let that = this;
            if (that.seriesIds && that.seriesIds.length > 0) {
                that.$confirm('您确定要移除车型的关联吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    that.loading = true;
                    that.$util
                        .axiosPost({
                            url: '/api/EntpGoods/RemoveBindSeriesData',
                            data: {
                                SeriesIds: that.seriesIds,
                                GoodsId: that.GoodsId
                            },
                            hideLoading: true
                        })
                        .then(resp => {
                            if (resp.errcode == 0) {
                                that.$util.successMsg('移除成功');
                                that.getTableData();
                            }
                        })
                        .finally(() => {
                            that.loading = false;
                        });
                });
            }
        },
        confirmSeriesButton(row) {
            let that = this;
            let ids = [];
            row.forEach(ele => {
                let item = ele;
                //EngineType==undefined的是车型选择的操作，反之是通过发动机选择的
                if (this.dialogVisible && item.EngineType == undefined) {
                    let id = ele[4].split('{$}')[0];
                    ids.push(id);
                }
            });
            if (ids.length > 0) {
                that.loading = true;
                that.$util
                    .axiosPost({
                        url: '/api/EntpGoods/BindSeriesData',
                        data: {
                            SeriesIds: ids,
                            GoodsId: that.GoodsId
                        },
                        hideLoading: true
                    })
                    .then(resp => {
                        if (resp.errcode == 0) {
                            that.$util.successMsg('关联成功');
                            that.getTableData();
                        }
                    })
                    .finally(() => {
                        that.loading = false;
                    });
            }
            this.dialogVisible = false;
        }
    }
};
</script>
<style lang="less" scoped>
.search-ctn {
    margin-top: 10px;
}
.table-ctn .el-table {
    margin-bottom: 0;
}
</style>
